/**
 * First-run detection.
 *
 * We store a version-tagged flag so we can re-onboard users after a
 * major product change by bumping the suffix (e.g. `.v2`).
 */
const KEY = 'polybot.onboarded.v1';

export function isOnboarded(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function markOnboarded(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    /* storage blocked — fine, will show onboarding again */
  }
}

/** Drop the onboarded flag so the next navigation to / shows /welcome again. */
export function resetOnboarded(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
